<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 164"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>pet-owners</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <circle
        id="path-1"
        cx="90"
        cy="90"
        r="90" />
    </defs>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-592.000000, -652.000000)">
        <g
          id="pet-owners"
          transform="translate(592.000000, 648.000000)">
          <mask
            id="mask-2"
            fill="white">
            <use xlink:href="#path-1" />
          </mask>
          <g
            id="Oval"
            fill-rule="nonzero" />
          <path
            id="Path"
            d="M178.875037,94.5 C178.871558,57.7453739 156.519038,24.6858915 122.411436,10.9901229 C88.3038349,-2.7056456 49.2953147,5.71456088 23.8739976,32.2599783 C-1.54731958,58.8053956 -8.27284101,98.1415353 6.885,131.625 L170.865,131.625 C176.155341,119.96394 178.886604,107.304995 178.875037,94.5 Z"
            class="fill-extra-light"
            fill-rule="nonzero"
            mask="url(#mask-2)" />
          <line
            id="Path"
            x1="1.125"
            y1="131.625"
            x2="176.625"
            y2="131.625"
            class="stroke"
            stroke-width="2.25"
            stroke-linecap="round"
            stroke-linejoin="round"
            mask="url(#mask-2)" />
          <g
            id="Group"
            mask="url(#mask-2)">
            <g transform="translate(-24.750000, 4.500000)">
              <polygon
                id="Path"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="4.9275 164.655 68.355 127.125 4.9275 127.125" />
              <polygon
                id="Path"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="226.8225 164.655 163.395 127.125 226.8225 127.125" />
              <polygon
                id="Path"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="54 127.125 0 148.5 0 103.5 54 101.25" />
              <path
                id="Path"
                d="M218.25,34.875 L166.5,34.875 C165.257359,34.875 164.25,35.8823593 164.25,37.125 L164.25,127.125 L218.25,127.125 L218.25,34.875 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M218.25,34.875 L166.5,34.875 C165.257359,34.875 164.25,35.8823593 164.25,37.125 L164.25,127.125 L218.25,127.125 L218.25,34.875 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,61.875 L175.5,61.875 L175.5,48.375 C175.5,47.1323593 176.507359,46.125 177.75,46.125 L184.5,46.125 C185.742641,46.125 186.75,47.1323593 186.75,48.375 L186.75,61.875 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M184.5,46.125 L177.75,46.125 C176.507359,46.125 175.5,47.1323593 175.5,48.375 L175.5,59.625 L186.75,48.375 C186.75,47.1323593 185.742641,46.125 184.5,46.125 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M186.75,61.875 L175.5,61.875 L175.5,48.375 C175.5,47.1323593 176.507359,46.125 177.75,46.125 L184.5,46.125 C185.742641,46.125 186.75,47.1323593 186.75,48.375 L186.75,61.875 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,66.375 L175.5,66.375 C174.257359,66.375 173.25,65.3676407 173.25,64.125 L173.25,64.125 C173.25,62.8823593 174.257359,61.875 175.5,61.875 L186.75,61.875 C187.992641,61.875 189,62.8823593 189,64.125 L189,64.125 C189,65.3676407 187.992641,66.375 186.75,66.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,61.875 L196.875,61.875 L196.875,48.375 C196.875,47.1323593 197.882359,46.125 199.125,46.125 L205.875,46.125 C207.117641,46.125 208.125,47.1323593 208.125,48.375 L208.125,61.875 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M205.875,46.125 L199.125,46.125 C197.882359,46.125 196.875,47.1323593 196.875,48.375 L196.875,59.625 L208.125,48.375 C208.125,47.1323593 207.117641,46.125 205.875,46.125 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M208.125,61.875 L196.875,61.875 L196.875,48.375 C196.875,47.1323593 197.882359,46.125 199.125,46.125 L205.875,46.125 C207.117641,46.125 208.125,47.1323593 208.125,48.375 L208.125,61.875 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,66.375 L196.875,66.375 C195.632359,66.375 194.625,65.3676407 194.625,64.125 L194.625,64.125 C194.625,62.8823593 195.632359,61.875 196.875,61.875 L208.125,61.875 C209.367641,61.875 210.375,62.8823593 210.375,64.125 L210.375,64.125 C210.375,65.3676407 209.367641,66.375 208.125,66.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,90 L196.875,90 L196.875,76.5 C196.875,75.2573593 197.882359,74.25 199.125,74.25 L205.875,74.25 C207.117641,74.25 208.125,75.2573593 208.125,76.5 L208.125,90 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M205.875,74.25 L199.125,74.25 C197.882359,74.25 196.875,75.2573593 196.875,76.5 L196.875,87.75 L208.125,76.5 C208.125,75.2573593 207.117641,74.25 205.875,74.25 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M208.125,90 L196.875,90 L196.875,76.5 C196.875,75.2573593 197.882359,74.25 199.125,74.25 L205.875,74.25 C207.117641,74.25 208.125,75.2573593 208.125,76.5 L208.125,90 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,94.5 L196.875,94.5 C195.632359,94.5 194.625,93.4926407 194.625,92.25 L194.625,92.25 C194.625,91.0073593 195.632359,90 196.875,90 L208.125,90 C209.367641,90 210.375,91.0073593 210.375,92.25 L210.375,92.25 C210.375,93.4926407 209.367641,94.5 208.125,94.5 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,90 L175.5,90 L175.5,76.5 C175.5,75.2573593 176.507359,74.25 177.75,74.25 L184.5,74.25 C185.742641,74.25 186.75,75.2573593 186.75,76.5 L186.75,90 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M184.5,74.25 L177.75,74.25 C176.507359,74.25 175.5,75.2573593 175.5,76.5 L175.5,87.75 L186.75,76.5 C186.75,75.2573593 185.742641,74.25 184.5,74.25 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M186.75,90 L175.5,90 L175.5,76.5 C175.5,75.2573593 176.507359,74.25 177.75,74.25 L184.5,74.25 C185.742641,74.25 186.75,75.2573593 186.75,76.5 L186.75,90 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,94.5 L175.5,94.5 C174.257359,94.5 173.25,93.4926407 173.25,92.25 L173.25,92.25 C173.25,91.0073593 174.257359,90 175.5,90 L186.75,90 C187.992641,90 189,91.0073593 189,92.25 L189,92.25 C189,93.4926407 187.992641,94.5 186.75,94.5 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,117 L175.5,117 L175.5,103.5 C175.5,102.257359 176.507359,101.25 177.75,101.25 L184.5,101.25 C185.742641,101.25 186.75,102.257359 186.75,103.5 L186.75,117 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M184.5,101.25 L177.75,101.25 C176.507359,101.25 175.5,102.257359 175.5,103.5 L175.5,114.75 L186.75,103.5 C186.75,102.257359 185.742641,101.25 184.5,101.25 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M186.75,117 L175.5,117 L175.5,103.5 C175.5,102.257359 176.507359,101.25 177.75,101.25 L184.5,101.25 C185.742641,101.25 186.75,102.257359 186.75,103.5 L186.75,117 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M186.75,121.5 L175.5,121.5 C174.257359,121.5 173.25,120.492641 173.25,119.25 L173.25,119.25 C173.25,118.007359 174.257359,117 175.5,117 L186.75,117 C187.992641,117 189,118.007359 189,119.25 L189,119.25 C189,120.492641 187.992641,121.5 186.75,121.5 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,117 L196.875,117 L196.875,103.5 C196.875,102.257359 197.882359,101.25 199.125,101.25 L205.875,101.25 C207.117641,101.25 208.125,102.257359 208.125,103.5 L208.125,117 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M205.875,101.25 L199.125,101.25 C197.882359,101.25 196.875,102.257359 196.875,103.5 L196.875,114.75 L208.125,103.5 C208.125,102.257359 207.117641,101.25 205.875,101.25 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M208.125,117 L196.875,117 L196.875,103.5 C196.875,102.257359 197.882359,101.25 199.125,101.25 L205.875,101.25 C207.117641,101.25 208.125,102.257359 208.125,103.5 L208.125,117 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M208.125,121.5 L196.875,121.5 C195.632359,121.5 194.625,120.492641 194.625,119.25 L194.625,119.25 C194.625,118.007359 195.632359,117 196.875,117 L208.125,117 C209.367641,117 210.375,118.007359 210.375,119.25 L210.375,119.25 C210.375,120.492641 209.367641,121.5 208.125,121.5 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M136.8,73.125 L164.25,73.125 L164.25,79.875 L138.375,79.875 C137.132359,79.875 136.125,78.8676407 136.125,77.625 L136.125,73.8 C136.118647,73.619106 136.187721,73.443701 136.315711,73.3157108 C136.443701,73.1877205 136.619106,73.1186469 136.8,73.125 L136.8,73.125 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M148.5,120.375 L164.25,120.375 L164.25,127.125 L146.25,127.125 L146.25,122.625 C146.25,121.382359 147.257359,120.375 148.5,120.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M164.25,61.875 L139.5,61.875 C138.257359,61.875 137.25,62.8823593 137.25,64.125 L137.25,73.125 L164.25,73.125 L164.25,61.875 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M213.75,25.875 L168.75,25.875 C167.507359,25.875 166.5,26.8823593 166.5,28.125 L166.5,34.875 L216,34.875 L216,28.125 C216,26.8823593 214.992641,25.875 213.75,25.875 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="141.75"
                y1="61.875"
                x2="141.75"
                y2="73.125"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="146.25"
                y1="61.875"
                x2="146.25"
                y2="73.125"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="150.75"
                y1="61.875"
                x2="150.75"
                y2="73.125"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="155.25"
                y1="61.875"
                x2="155.25"
                y2="73.125"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="159.75"
                y1="61.875"
                x2="159.75"
                y2="73.125"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M139.14,41.31 L164.249991,37.125 L164.249991,46.125 L139.5,46.125 C138.257359,46.125 137.249991,45.1176407 137.249991,43.875 L137.249991,43.5375 C137.246812,42.4313634 138.048109,41.486978 139.14,41.31 L139.14,41.31 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M139.14,90.81 L164.249991,86.625 L164.249991,95.625 L139.5,95.625 C138.257359,95.625 137.249991,94.6176407 137.249991,93.375 L137.249991,93.0375 C137.246812,91.9313634 138.048109,90.986978 139.14,90.81 L139.14,90.81 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="171"
                y1="25.875"
                x2="171"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="175.5"
                y1="25.875"
                x2="175.5"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="180"
                y1="25.875"
                x2="180"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="184.5"
                y1="25.875"
                x2="184.5"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="189"
                y1="25.875"
                x2="189"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="193.5"
                y1="25.875"
                x2="193.5"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="198"
                y1="25.875"
                x2="198"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="202.5"
                y1="25.875"
                x2="202.5"
                y2="34.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M150.75,111.375 L164.25,111.375 L164.25,120.375 L148.5,120.375 L148.5,113.625 C148.5,112.382359 149.507359,111.375 150.75,111.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M77.3325,78.9525 C83.6058658,73.841846 85.9840948,65.3362681 83.2712396,57.7129933 C80.5583843,50.0897184 73.3415945,44.9986702 65.25,45 C64.1102664,45.0012307 62.9730323,45.1066696 61.8525,45.315 C61.8525,45.315 61.8525,45.1125 61.8525,45 C61.8525,34.4375542 53.2899458,25.875 42.7275,25.875 C32.1650542,25.875 23.6025,34.4375542 23.6025,45 C23.6025,45.405 23.6025,45.7875 23.6025,46.17 C18.5266139,46.5909943 14.2295308,50.0843226 12.7810543,54.9673311 C11.3325778,59.8503396 13.029717,65.1217705 17.055,68.2425 C14.0636051,75.6074478 15.9760235,84.0562069 21.8475,89.415 C20.7664599,91.3037654 20.2145974,93.4490338 20.25,95.625 C20.2205816,101.473811 24.2971977,106.541542 30.0164903,107.765939 C35.735783,108.990335 41.5298344,106.035735 43.8975,100.6875 C46.5715694,102.87032 50.0358116,103.837053 53.4537453,103.35427 C56.871679,102.871487 59.9326313,100.98307 61.8975,98.145 C63.9013236,99.4598616 66.2509211,100.149077 68.6475,100.125 C73.6656609,100.126769 78.1880886,97.0978859 80.0967678,92.4568854 C82.0054471,87.8158849 80.9224568,82.4816918 77.355,78.9525 L77.3325,78.9525 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M77.3325,78.9525 C83.6058658,73.841846 85.9840948,65.3362681 83.2712396,57.7129933 C80.5583843,50.0897184 73.3415945,44.9986702 65.25,45 C64.1102664,45.0012307 62.9730323,45.1066696 61.8525,45.315 C61.8525,45.315 61.8525,45.1125 61.8525,45 C61.8525,34.4375542 53.2899458,25.875 42.7275,25.875 C32.1650542,25.875 23.6025,34.4375542 23.6025,45 C23.6025,45.405 23.6025,45.7875 23.6025,46.17 C18.5266139,46.5909943 14.2295308,50.0843226 12.7810543,54.9673311 C11.3325778,59.8503396 13.029717,65.1217705 17.055,68.2425 C14.0636051,75.6074478 15.9760235,84.0562069 21.8475,89.415 C20.7664599,91.3037654 20.2145974,93.4490338 20.25,95.625 C20.2205816,101.473811 24.2971977,106.541542 30.0164903,107.765939 C35.735783,108.990335 41.5298344,106.035735 43.8975,100.6875 C46.5715694,102.87032 50.0358116,103.837053 53.4537453,103.35427 C56.871679,102.871487 59.9326313,100.98307 61.8975,98.145 C63.9013236,99.4598616 66.2509211,100.149077 68.6475,100.125 C73.6656609,100.126769 78.1880886,97.0978859 80.0967678,92.4568854 C82.0054471,87.8158849 80.9224568,82.4816918 77.355,78.9525 L77.3325,78.9525 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M67.5,82.125 C67.5,79.6397186 65.4852814,77.625 63,77.625 C63,73.8970779 59.9779221,70.875 56.25,70.875 C52.5220779,70.875 49.5,73.8970779 49.5,77.625"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M55.125,57.375 C55.125,54.8897186 53.1102814,52.875 50.625,52.875 C50.625,49.1470779 47.6029221,46.125 43.875,46.125 C40.1470779,46.125 37.125,49.1470779 37.125,52.875"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <ellipse
                id="Oval"
                stroke="none"
                class="fill-extra-light"
                fill-rule="nonzero"
                cx="111.9375"
                cy="159.2325"
                rx="53.685"
                ry="3.8925" />
              <path
                id="Path"
                d="M77.6475,132.075 C77.6475,132.075 78.9525,146.25 95.76,146.25 C112.5675,146.25 111.285,117.81 111.285,117.81"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M85.5,152.775 L84.5325,152.775 C86.7840684,150.823179 88.0805356,147.992285 88.0875,145.0125 C88.0875,139.2975 83.4525,132.075 77.7375,132.075 C72.0225,132.075 67.3875,139.2975 67.3875,145.0125 C67.368546,147.983472 68.641193,150.816138 70.875,152.775 L69.885,152.775 C67.635,152.775 66.4425,154.3275 66.105,156.465 C66.0611248,156.838827 66.1753072,157.213998 66.42,157.5 C66.6618301,157.783407 67.014947,157.947647 67.3875,157.950081 L87.9075,157.950081 C88.2879092,157.954258 88.6505761,157.789409 88.8975,157.5 C89.144745,157.216032 89.2520397,156.836374 89.19,156.465 C88.875,154.3275 87.75,152.775 85.5,152.775 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="77.6475"
                y1="157.95"
                x2="77.6475"
                y2="147.6"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M73.4625,118.3275 C74.2888561,120.303299 73.3570487,122.574894 71.38125,123.40125 C69.4054513,124.227606 67.1338561,123.295799 66.3075,121.32 C65.9550267,118.822094 66.0771643,116.280105 66.6675,113.8275 C66.7060113,113.565709 66.8770758,113.342409 67.1198133,113.23707 C67.3625507,113.131731 67.6424887,113.159313 67.86,113.31 C70.0302475,114.610103 71.9318909,116.313182 73.4625,118.3275 L73.4625,118.3275 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M81.8325,118.3275 C81.0061439,120.303299 81.9379513,122.574894 83.91375,123.40125 C85.8895487,124.227606 88.1611439,123.295799 88.9875,121.32 C89.3510498,118.822617 89.2288111,116.278523 88.6275,113.8275 C88.5889887,113.565709 88.4179242,113.342409 88.1751867,113.23707 C87.9324493,113.131731 87.6525113,113.159313 87.435,113.31 C85.2647525,114.610103 83.3631091,116.313182 81.8325,118.3275 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M77.6475,139.8375 C69.885,139.8375 60.7725,119.1375 77.6475,119.1375 C94.5225,119.1375 85.5,139.8375 77.6475,139.8375 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M79.065,119.25 C77.4592292,121.96954 77.2048566,125.279833 78.3762738,128.21278 C79.5476909,131.145726 82.0125503,133.36996 85.05,134.235 C88.4475,128.25 88.695,119.925 79.065,119.25 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M74.4075,124.3125 C73.6137289,124.312552 72.8985712,124.791953 72.5969531,125.526187 C72.2953351,126.260421 72.4669758,127.104112 73.0314917,127.662139 C73.5960076,128.220166 74.4416268,128.382042 75.1723247,128.071957 C75.9030225,127.761871 76.3741238,127.041219 76.365,126.2475 C76.3526739,125.1752 75.4798712,124.312429 74.4075,124.3125 L74.4075,124.3125 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M81,124.3125 C80.2042435,124.303405 79.4821833,124.776968 79.173444,125.510447 C78.8647047,126.243926 79.0307447,127.091312 79.5934663,127.654034 C80.1561879,128.216755 81.0035743,128.382795 81.7370532,128.074056 C82.470532,127.765317 82.9440952,127.043257 82.935,126.2475 C82.935,125.178829 82.068671,124.3125 81,124.3125 L81,124.3125 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <path
                id="Shape"
                d="M77.6475,136.9125 C77.7488502,136.912748 77.8459588,136.95321 77.9175,137.025 L77.6475,137.2275 L77.4,137.025 C77.4646248,136.956592 77.553467,136.91621 77.6475,136.9125 M77.6475,134.6625 C76.2184632,134.6625 75.06,135.820963 75.06,137.25 C75.06,138.69 77.6475,139.8375 77.6475,139.8375 C77.6475,139.8375 80.235,138.69 80.235,137.25 C80.2410628,136.561912 79.9703993,135.900242 79.4838285,135.413672 C78.9972576,134.927101 78.3355884,134.656437 77.6475,134.6625 Z"
                stroke="none"
                fill="#0066A4"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M77.6475,139.8375 C69.885,139.8375 60.7725,119.1375 77.6475,119.1375 C94.5225,119.1375 85.5,139.8375 77.6475,139.8375 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <polygon
                id="Path"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero"
                points="116.46 110.07 121.6575 157.95 139.7475 157.95 144.9225 110.07" />
              <polygon
                id="Path"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="116.46 110.07 121.6575 157.95 139.7475 157.95 144.9225 110.07" />
              <path
                id="Path"
                d="M144.945,111.375 C144.945,113.22 144.945,111.87 144.945,117.2025 C144.945,119.687781 146.959719,121.7025 149.445,121.7025 C151.930281,121.7025 153.945,119.687781 153.945,117.2025 L153.945,111.375 L144.945,111.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M107.415,111.375 L107.415,117.2025 C107.415,119.687781 109.429719,121.7025 111.915,121.7025 C114.400281,121.7025 116.415,119.687781 116.415,117.2025 L116.415,111.375 L107.415,111.375 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="130.7025"
                y1="129.4875"
                x2="130.7025"
                y2="157.95"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M130.7025,157.95 C130.7025,153.66289 127.22711,150.1875 122.94,150.1875 L121.635,150.1875 C118.826099,150.20289 116.244649,151.73455 114.885,154.1925 C114.482699,154.985509 114.515782,155.929541 114.972609,156.692442 C115.429436,157.455344 116.246001,157.930225 117.135,157.95 L130.7025,157.95 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M144.225,157.95 C145.11932,157.942714 145.945273,157.470132 146.404736,156.702828 C146.864199,155.935525 146.890824,154.984303 146.475,154.1925 C145.118913,151.731097 142.535225,150.198108 139.725,150.187467 L138.4425,150.187467 C136.381924,150.181501 134.404014,150.997407 132.946961,152.454461 C131.489907,153.911514 130.674001,155.889424 130.679967,157.95 L144.225,157.95 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M153.99,111.375 L153.99,85.5 C153.99,72.6386689 143.563831,62.2125 130.7025,62.2125 C117.841169,62.2125 107.415,72.6386689 107.415,85.5 L107.415,111.375 L116.415,111.375 L116.415,99.7425 L144.945,99.7425 L144.945,111.375 L153.99,111.375 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <line
                id="Path"
                x1="111.33"
                y1="72.5625"
                x2="150.0525"
                y2="72.5625"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="107.73"
                y1="81.6075"
                x2="153.6525"
                y2="81.6075"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="107.415"
                y1="90.675"
                x2="153.99"
                y2="90.675"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="107.415"
                y1="99.7425"
                x2="116.4825"
                y2="99.7425"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="144.945"
                y1="99.7425"
                x2="153.99"
                y2="99.7425"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M153.99,111.375 L153.99,85.5 C153.99,72.6386689 143.563831,62.2125 130.7025,62.2125 C117.841169,62.2125 107.415,72.6386689 107.415,85.5 L107.415,111.375 L116.415,111.375 L116.415,99.7425 L144.945,99.7425 L144.945,111.375 L153.99,111.375 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M117.765,75.15 C114.525,81.63 112.5675,83.655 115.0425,87.1425 C116.030753,88.5568607 116.528626,90.2559493 116.46,91.98 L116.46,99.7425"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M144.9225,99.7425 L144.9225,91.98 C144.851956,90.2523278 145.358596,88.5503365 146.3625,87.1425 C148.8375,83.655 146.88,81.63 143.64,75.15"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M130.7025,62.2125 C128.337856,62.2162846 125.986998,62.572705 123.7275,63.27 L130.7025,72.5625 L137.6775,63.27 C135.418002,62.572705 133.067144,62.2162846 130.7025,62.2125 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="130.7025"
                y1="72.5625"
                x2="130.7025"
                y2="86.805"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="116.4825"
                y="99.7425"
                width="28.4625"
                height="5.175" />
              <path
                id="Path"
                d="M144.945,110.07 L116.46,110.07 C115.651103,112.734181 115.219408,115.498543 115.1774,118.2825 L115.1774,126.9 C115.171437,127.588088 115.442101,128.249758 115.928672,128.736328 C116.415242,129.222899 117.076912,129.493563 117.765,129.4876 L143.64,129.4876 C144.330138,129.493501 144.994074,129.223542 145.484201,128.73764 C145.974329,128.251738 146.25,127.590164 146.25,126.9 L146.25,118.2825 C146.189599,115.498472 145.75057,112.735617 144.945,110.07 L144.945,110.07 Z"
                stroke="none"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M144.945,110.07 L116.46,110.07 C115.651103,112.734181 115.219408,115.498543 115.1774,118.2825 L115.1774,126.9 C115.171437,127.588088 115.442101,128.249758 115.928672,128.736328 C116.415242,129.222899 117.076912,129.493563 117.765,129.4876 L143.64,129.4876 C144.330138,129.493501 144.994074,129.223542 145.484201,128.73764 C145.974329,128.251738 146.25,127.590164 146.25,126.9 L146.25,118.2825 C146.189599,115.498472 145.75057,112.735617 144.945,110.07 L144.945,110.07 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="116.4825"
                y="104.9175"
                width="28.4625"
                height="5.175" />
              <path
                id="Path"
                d="M139.9275,11.8575 C139.033905,10.2054849 137.305706,9.17720627 135.4275,9.17999432 L126,9.17999432 C124.123145,9.18211898 122.397268,10.2090156 121.5,11.8575 L116.865,20.25 C121.33252,18.8047571 126.00762,18.1053925 130.7025,18.1799943 C135.39738,18.1053925 140.07248,18.8047571 144.54,20.25 L139.9275,11.8575 Z"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M148.815,41.49 C148.802087,39.9785732 147.731818,38.6829835 146.25,38.385 L146.25,36.315 C146.25,27.7407793 139.299221,20.79 130.725,20.79 C122.150779,20.79 115.2,27.7407793 115.2,36.315 L115.2,38.385 C113.642283,38.6838246 112.544621,40.0871733 112.629773,41.6710068 C112.714925,43.2548404 113.956723,44.5324116 115.5375,44.6625 C117.037192,51.8619213 123.382289,57.0214893 130.73625,57.0214893 C138.090211,57.0214893 144.435308,51.8619213 145.935,44.6625 C147.566916,44.500823 148.811441,43.1299016 148.815,41.49 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="122.2875"
                cy="43.4475"
                r="1.935" />
              <circle
                id="Oval"
                stroke="none"
                class="fill-light"
                fill-rule="nonzero"
                cx="139.1175"
                cy="43.4475"
                r="1.935" />
              <path
                id="Path"
                d="M126.8325,48.0825 C129.18099,49.6553158 132.24651,49.6553158 134.595,48.0825"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M137.7,38.9025 C136.830829,38.0739281 135.464171,38.0739281 134.595,38.9025"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M126.8325,38.9025 C125.960408,38.0595292 124.577092,38.0595292 123.705,38.9025"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M148.725,38.9025 C148.725,38.9025 148.725,38.4525 148.725,37.7325 L148.725,37.7325 C147.444434,33.2111097 144.184854,29.5130584 139.86,27.675 C145.62,36.3375 139.86,51.4575 139.86,58.2975 C139.86,63.8325 144.36,68.6925 147.105,71.055 C147.350398,71.2743122 147.708562,71.3120903 147.994316,71.1488025 C148.280069,70.9855148 148.429359,70.6577629 148.365,70.335 C145.6875,58.1625 150.21,50.04 148.725,38.9025 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M121.68,27.6975 C117.355146,29.5355584 114.095566,33.2336097 112.815,37.755 L112.815,37.755 C112.815,38.475 112.815,38.925 112.7025,38.925 C111.24,50.175 115.74,58.185 113.1525,70.425 C113.073878,70.757145 113.224806,71.101191 113.522435,71.2682807 C113.820063,71.4353704 114.192376,71.3850737 114.435,71.145 C117.0675,68.7825 121.68,63.9225 121.68,58.3875 C121.6575,51.48 115.9425,36.36 121.68,27.6975 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M139.9275,11.8575 C139.033905,10.2054849 137.305706,9.17720627 135.4275,9.17999432 L126,9.17999432 C124.123145,9.18211898 122.397268,10.2090156 121.5,11.8575 L116.865,20.25 C121.33252,18.8047571 126.00762,18.1053925 130.7025,18.1799943 C135.39738,18.1053925 140.07248,18.8047571 144.54,20.25 L139.9275,11.8575 Z"
                class="stroke"
                stroke-width="2.25"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M130.7025,25.9875 C127.415653,25.9131249 124.154472,26.5822823 121.1625,27.945 C123.437375,31.7131204 127.587501,33.9391757 131.985,33.75 C131.985,31.815 135.4725,26.415 139.725,27.6975 C136.870062,26.503192 133.796457,25.9206633 130.7025,25.9875 L130.7025,25.9875 Z"
                class="stroke fill-white"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M130.7025,18.225 C117.8325,18.225 107.415,22.725 107.415,29.88 C107.415,33.705 108.045,36.0675 112.815,37.755 C112.815,37.755 115.29,25.9875 130.815,25.9875 C146.34,25.9875 148.815,37.755 148.815,37.755 C153.585,36.0675 154.215,33.705 154.215,29.88 C153.99,22.725 143.5725,18.225 130.7025,18.225 Z"
                class="stroke fill-light"
                stroke-width="2.25"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <circle
                id="Oval"
                stroke="none"
                fill="none"
                cx="115.875"
                cy="90"
                r="90" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
